/**
 * program
 * Program APIs
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramOfferDto } from './programOfferDto';
import { ProgramMedicationOrderDto } from './programMedicationOrderDto';
import { OrderDto } from './orderDto';
import { WeightLossProtocolDataDto } from './weightLossProtocolDataDto';
import { ProgramConfigDto } from './programConfigDto';
import { SubscriptionDto } from './subscriptionDto';
import { FlowCurrentDto } from './flowCurrentDto';
import { ProgramDeliveryDto } from './programDeliveryDto';


export interface WeightLossProgramDetailsDto { 
    /**
     * The program identifier.
     */
    id: string;
    /**
     * The patient identifier who is enrolled in the program.
     */
    patientId: string;
    /**
     * The program status
     */
    status: WeightLossProgramDetailsDto.StatusEnum;
    /**
     * The source from which the patient entered the program.
     */
    entryPoint: string;
    /**
     * The program start time. Program is considered started once it is active.
     */
    startTime?: string;
    /**
     * The program end time. Program is considered ended once the subscription is cancelled.
     */
    endTime?: any;
    /**
     * The program intake information.
     */
    intake?: any;
    /**
     * The program protocol data.
     */
    protocolData?: WeightLossProtocolDataDto;
    /**
     * The program configuration.
     */
    config: ProgramConfigDto;
    /**
     * The collection of delivery addresses.
     */
    deliveryAddresses: Array<ProgramDeliveryDto>;
    /**
     * The collection of medication orders.
     */
    medicationOrders: Array<ProgramMedicationOrderDto>;
    /**
     * The collection of program offers.
     */
    offers: Array<ProgramOfferDto>;
    /**
     * The program subscription
     */
    subscriptions: Array<SubscriptionDto>;
    /**
     * The collection of (payment) orders.
     */
    orders: Array<OrderDto>;
    /**
     * The collection of flows associated with the program.
     */
    flows: Array<FlowCurrentDto>;
}
export namespace WeightLossProgramDetailsDto {
    export type StatusEnum = 'pending' | 'active' | 'ended';
    export const StatusEnum = {
        Pending: 'pending' as StatusEnum,
        Active: 'active' as StatusEnum,
        Ended: 'ended' as StatusEnum
    };
}


